<template>
  <b-container>
    <div class="b-main-content">
      <h3>Machine List</h3>
      <table id="customers">
        <tr>
          <th>Machine ID</th>
          <th>Site Description</th>
          <th>Type</th>
          <th>Total Bales</th>
          <th>Active</th>
        </tr>
        <template v-for="item in items">
          <tr :key="item.ThingName">
            <td><router-link :to="item.Link">{{ item.ThingName }}</router-link></td>
            <td>{{ item.Description }}</td>
            <td>{{ item.Type }}</td>
            <td>{{ item.Bales }}</td>
            <td>{{ item.Time | moment("from") }}</td>
            <!--    <td><timeago :datetime="item.Time"></timeago></td>    -->
          </tr>
        </template>
      </table>
    </div>
  </b-container> 
</template>

<script>
import { API } from 'aws-amplify'
import { mapState } from 'vuex'

export default {
    created: function () {
      //Fetch the data when the view is created and the data is already being observed
      this.updateTable()
    },
    watch: {
      '$route': 'updateTable'
    },

    computed: {
        ...mapState({
            user: state => state.auth.user,
        })
    },
    data: function () {
        return {
            items: [
            {
                "ThingName": "Loading...",
                "Link": "/machine",
                "Time": Date.now()
            }
            ]
        }
    },

    methods: {
      updateTable: function() {
        this.items.splice(1)
        //this.$set(this.items[0], 'ThingName', 'Loading...')
        this.$set(this.items, 0, { "ThingName": "Loading...", "Link": "/machine", "Time": Date.now()})
        API.get('gbkpulseapi', '/listmachine', []).then(response => {
          // Add your code here
          console.log("api response =", response)
          var body = JSON.parse(response.body)
          console.log("body =", body)
          console.log("body[0] =", body[0])

          for (var i = 0; i < body.length; i++) {
            var newitem = []
            newitem.ThingName = body[i].machineID
            newitem.Link = '/machine/' + body[i].machineID
            newitem.Description = body[i].description
            newitem.Type = body[i].type
            newitem.Location = body[i].position
            newitem.Time = body[i].time
            newitem.Bales = body[i].bale

            this.$set(this.items, i, newitem)
            
            console.log("i = ", i)
            console.log("machineID =",body[i].machineID)
          }
        }).catch(error => {
          console.log(error.response)
        })
      }
    }
    
}
</script>

<style scoped>
h3 {
  text-align: left;
  margin: 0px 8px 0px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

#customers {
    font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
    border-collapse: collapse;
    width: 100%;
}

#customers td, #customers th {
    border: 1px solid #ddd;
    text-align: left;
    padding: 8px;
}



#customers tr:nth-child(even){background-color: #f2f2f2;}

#customers tr:hover {background-color: #ddd;}

#customers th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    background-color: #4CAF50;
    color: white;
}


</style>
